import React, { Component } from 'react'
import API from '../../../api/auth'
import MessageConstants from '../../../constants/MessageConstants.js'
import ChatLink from '../../shared/ChatLink'
import forgotPasswordSentSrc from '../../../assets/svg/email_sent.svg'
import './style.css'
import { Div, H1, P, Button, Form, Input, Icon, Colorway } from '@driftt/tide-core'
import { Link } from 'react-router-dom'

class ForgotPassword extends Component {

  constructor(props){
    super(props)

    const defaultEmail = this.props.location.state ? this.props.location.state.forgotPasswordState : ''
    const defaultMessage = this.props.location.state ? this.props.location.state.error || '' : ''

    this.state = {
      requestStatus: null,
      email: defaultEmail,
      error: defaultMessage,
      success: false,
      loading: false
    }
    this.submitSendReset = this.submitSendReset.bind(this)
    this.handleEmailInput = this.handleEmailInput.bind(this)
  }

  handleEmailInput(event) {
    this.setState({ email: event.target.value, error: '' })
  }

  submitSendReset(event){
    event.preventDefault()
    const resetCallback = (response) => {
      if (response.status === 400) {
        this.setState({ error: MessageConstants.FORGOT_PASSWORD_NO_ACCOUNT, loading: false })
      } else if (response.status === 200) {
        this.setState({ success: true, error: '', loading: false })
      } else {
        this.setState({ error: MessageConstants.DEFAULT_SERVER_ERROR, loading: false})
      }
    }

    const existenceCallback = (response) => {
      if (response.status === 404) {
        this.setState({ error: MessageConstants.FORGOT_PASSWORD_NO_ACCOUNT, loading: false })
      } else if (response.status === 200) {
        API.sendReset(this.state.email, resetCallback)
      } else {
        this.setState({ error: MessageConstants.DEFAULT_SERVER_ERROR, loading: false })
      }
    }

    this.setState({ loading: true }, () => API.checkEmail(this.state.email, existenceCallback))
  }

  renderSuccess(){
    return (
      <Div className="forgot-success">
        <Colorway className="forgot-password-success-colorway">
          <Icon name="cw-invite-success" />
        </Colorway>
        <H1 className="password-reset-header">Password reset</H1>
        <P>{ MessageConstants.SENT_PASSWORD_RESET }</P>
      </Div>
    )
  }

  render() {
    if (this.state.success) return this.renderSuccess()
    const { loading } = this.state

    return (
      <Div className="forgot-password-page">
      	<H1>Reset password</H1>
        <P>{MessageConstants.FORGOT_HELPER}</P>
        <br/>
        <Form className="drift-form">
          <Input onChange={this.handleEmailInput} defaultValue={ this.state.email } size="large" type="email" placeholder="Your email" required />
          {this.state.error && <strong className="request-status error">{ this.state.error }</strong> }
          <Button size="large" onClick={this.submitSendReset} loading={loading}>Send reset email</Button>
          <ChatLink />
        </Form>
        <Button
          className="solo-link"
          type="utility"
          icon="arrow-1-left"
          href="/login"
        >
          Back
        </Button>
      </Div>
    )
  }
}

export default ForgotPassword



// WEBPACK FOOTER //
// ./src/components/pages/ForgotPassword/index.js